import React, { forwardRef } from 'react';
import { BaseButton } from './base-button';
export const createButton = useHook => /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const componentProps = useHook(props);
  return /*#__PURE__*/React.createElement(BaseButton, Object.assign({
    ref: forwardedRef
  }, componentProps));
});